import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { CONTROLLER_COMPONENTS } from 'components/ui/FactoryTable';
import { FormAggregationRow } from 'entities/FormAggregationRow';
import { TableCellEntityMode } from 'entities/TableCell';
import { useLocalStore } from 'hooks/';
import { TableCellController } from 'stores/common';

import s from './SummaryIndicatorItem.module.scss';

type Props = {
  entity: FormAggregationRow;
};

const SummaryIndicatorItem: React.FC<Props> = ({ entity }) => {
  const Component = CONTROLLER_COMPONENTS[entity.controllerKind];

  const store = useLocalStore(() => {
    return new TableCellController({
      fieldId: entity.id,
      comments: null,
      errors: null,
      mode: TableCellEntityMode.disabled,
      parentRowModel: null,
      ...entity,
    });
  });

  React.useEffect(() => {
    /* Обновляем значение, если пересчиталась аггрегация */
    store.controller.setValue(entity.controller.value);
  }, [entity, store.controller]);

  return (
    <div className={s['summary-indicator-item']}>
      <Typography.Title className={s.summaryIndicatorItem__price} level={4}>
        <Component
          className={s.summaryIndicatorItem__price}
          record={store.controller}
        />
      </Typography.Title>
      <div className={s.summaryIndicatorItem__title}>
        <Typography.Text>{entity.title}</Typography.Text>
      </div>
    </div>
  );
};

export default observer(SummaryIndicatorItem);
